// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchInput_wrapper__PoyqH","wrapper_input":"SearchInput_wrapper_input__UcTH9"};